import styled from 'styled-components';

import { TileContainer } from '~src/styles/containers.sc';

export const TileContainerExt = styled(TileContainer)`
  margin-top: 15px;
  padding: 30px 20px;

  .trigger {
    color: black;
  }
`;
